// extracted by css-extract-rspack-plugin
export default {"carouselContainer":"L1lvne6z","sliderTrack":"ZeaemgOG","slideWrapper":"Tx3xcehH","dotGroup":"b4_C8VfD"};